import type { MailboxInfo } from "owa-client-types";
import { type CopilotOnboardingStatus, getPersonalOSOnboardingStatusFromStore, } from "owa-copilot-settings-store";

/**
 * Returns the PersonalOS onboarding status passed through from the copilotsettings
 * response, but only when it is a real, actionable value — i.e. settings are
 * loaded and the status is present and not `Unknown`. Returns undefined
 * otherwise so callers fall back to their own onboarding lookup.
 */
export function getPersonalOSOnboardingStatus(mailboxInfo: MailboxInfo): Exclude<CopilotOnboardingStatus, "Unknown"> | undefined {
    const status = getPersonalOSOnboardingStatusFromStore(mailboxInfo);
    if (status === undefined || status === "Unknown") {
        return undefined;
    }
    return status;
}
